import React from 'react';
import { BlueCircle } from '../../AppStyle';

const BlueCircles = () => (
  <>
    <BlueCircle bottom="300px" left="220px" opacity="0.6" />
    <BlueCircle bottom="610px" left="380px" opacity="1" />
    <BlueCircle width="30px" height="30px" opacity="0.2" top="30px" left="20px" />
    <BlueCircle width="15px" height="15px" opacity="0.1" bottom="411px" left="333px" />
    <BlueCircle width="45px" height="45px" opacity="0.1" bottom="0px" right="0px" />
  </>
);

export default BlueCircles;
